import { useEffect } from 'react';
import { useStores } from 'hooks';

const useTitle = (title) => {
  const { uiStore } = useStores();
  useEffect(() => {
    uiStore.setTitle(title);
    return () => {
      uiStore.setTitle('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}

export default useTitle;
